var updateVisualization = (function () {
    var csrf_token;
    var requestUrl;
    var action_id;
    var status;

    function init($containerElement) {
        requestUrl = $($containerElement).data('url');
        csrf_token = $('input[name="csrfmiddlewaretoken"]').val();
        updateActionPlanData(true);

        $(".objective-item .dropdown-menu a").on("click", function () {
            var dropdown_toggle = $(this).parent().parent().find('.dropdown-toggle');
            var previous_status = dropdown_toggle.html().trim();
            var value = $(this).text();
            status = $(this).data('value');

            dropdown_toggle.html(value);
            dropdown_toggle.removeClass("not_done done in_progress").addClass(status);

            //Check if we need to update the database
            if (status !== previous_status) {
                action_id = $(this).parents('tr').data('id');
                updateActionPlanData(false);
            }
        });
    };

    function changeProgressBar(index, total, ratio, number_action) {
        var obj = $('#' + index);

        //Change progressbar
        obj.find('.progress-bar').css('width', ratio + "%");

        //Change texts
        obj.find('.percent').html(ratio + "%");
        obj.find('.remaining').html(number_action + " / " + total);
    }

    function updateActionPlanData(init) {
        let cookie_csrf_token = $('input[name="csrfmiddlewaretoken"]').val()
        $.ajaxSetup({
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-CSRFToken', cookie_csrf_token);
            }
        });
        $.ajax({
                type: 'POST',
                url: requestUrl,
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                data:
                    JSON.stringify({
                        'init': init,
                        'data': {
                            'action_id': action_id,
                            'status': status
                        }
                    }),
                success: function (data) {
                    var total = data.total_action;

                    var arr = {"not_done": data.not_done, "in_progress": data.in_progress, "done": data.done};

                    jQuery.each(arr, function (index, item) {
                        changeProgressBar(index, total, item.ratio, item.number_action);
                    });
                },
                error: function () {
                    alert("Une erreur est survenue lors de la requête.");
                },
            }
        );
    }

    return {
        init: init,
        updateActionPlanData: updateActionPlanData
    }
})();
